import { graphql } from 'gatsby'
import Layout from "../../components/App/Layout"
import SEO from "../../components/App/SEO"
import ProductBanner from '../../components/Products/ProductBanner'
import ProductCards from '../../components/Products/ProductCards'
import ProductDefeatChaos from '../../components/Products/ProductDefeatChaos'
import ProductFeatureList from '../../components/Products/ProductFeatureList'
import { ProductType } from '../../components/Products/ProductList'
import ProductNeeds from "../../components/Products/ProductNeeds"
import ProductNutshell from "../../components/Products/ProductNutshell"
import ProductPageBanner from '../../components/Products/ProductPageBanner'
import { useTranslation } from "../../plugins/i18next/ea-react-i18next"

export const Head = () => {
  return <SEO title='products.collaboration.title'  description='products.collaboration.description' />;
};

const EasyLife365Collaboration = () => {
  const { t } = useTranslation("pages", { keyPrefix: 'products.collaboration' });
    return (
      <Layout>
        <ProductPageBanner
          pageTitle={t('title')}
          homePageText={t('home')}
          homePageUrl="/"
          activePageText={t('title')}
          product={ProductType.Collab}
        />
        <ProductBanner product={ProductType.Collab}/>
        <ProductNeeds product={ProductType.Collab}/>
        <ProductFeatureList product={ProductType.Collab}/>
        <ProductNutshell product={ProductType.Collab}/>
        <ProductDefeatChaos product={ProductType.Collab}/>
        <ProductCards product={ProductType.Collab} isLandingPage={false}/>
      </Layout>)
  }

  export default EasyLife365Collaboration;

  export const query = graphql`
query ($language: String) {
  locales: allLocale(filter: {language: {eq: $language}, ns: {in: ["components","pages"]}}) {
    edges {
      node {
        ns
        language
        data
      }
    }
  }
  featurelistfiles:  allFile(filter: { extension: { eq: "pdf" } }) {
      edges {
        node {
          name
          ext
          publicURL
        }
      }
    }
}
`;
